'use strict';

/**
 * @ngdoc function
 * @name sharedModule.directive:maintenance
 * @description
 * # Need Assistance
 * Directive of the sharedModule
 */
(function (angular, window, undefined) {
  function maintenance($window, $rootScope, $location, modalFactory, MaintenanceService) {
    'ngInject'

    var directive = {
      restrict: 'E',
      scope: {

      },
      templateUrl: (window.location.hostname === 'localhost' ? '/app/' : '') + 'views/shared/maintenance.html',
      bindToController: true,
      controller: controller,
      controllerAs: 'self'
    };
    return directive;

    function controller() {
      'ngInject';//must be first line in function... needed by ng-annotate
      var self = this;
      self.maintenanceMessage = '';

      MaintenanceService.GetMaintenanceMessage({}).then(function () {
        if (MaintenanceService.data.message) {
          self.maintenanceMessage = MaintenanceService.data.message;
        }
      });
    }


  }
  angular.module('sharedModule')
    .directive('maintenance', maintenance);
})(angular, window);
